import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {TrustpilotRatingType} from 'hooks/useTrustpilotData/types/types';
import {useTrustpilotData} from 'hooks/useTrustpilotData/useTrustpilotData';
import {CustomerType} from 'hostApplicationStoreType';

export type PopupAdditionalDataType = {
    customer: CustomerType;
    popupProps: {platform: string};
    trustpilot?: TrustpilotRatingType;
    isLoading?: boolean;
};

/**
 * hook for preparing additional data for api popup
 * @returns {PopupAdditionalDataType} - prepared additional data for popup
 */
export const useExtraPopupData = (): PopupAdditionalDataType => {
    const customer = useGetCustomerData();

    const {isLoading, trustpilotRating: trustpilot} = useTrustpilotData();

    const popupProps = {
        platform: 'DESKTOP',
    };

    return {
        customer,
        isLoading,
        popupProps,
        trustpilot,
    };
};
